"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var React = _interopRequireWildcard(require("react"));
require("../../common/style.scss");
var _gemUrlFormatUtils = require("../../common/utils/domain/gemUrlFormatUtils");
var _tpmProductIntl = require("@tencent/tpm-product-intl");
var _reportUtil = require("../../utils/reportUtil");
var _componentUtils = require("../../common/componentUtils");
var _HTMLRenderer = _interopRequireDefault(require("../../common/components/HTMLRenderer"));
var cache;
function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var r, c, a = Object.defineProperty, n = { __proto__: null, default: e }; if (Object(e) !== e) return n; if (cache || "function" != typeof WeakMap || (cache = new WeakMap()), cache) { if (cache.has(e)) return cache.get(e); cache.set(e, n); } for (c in e) "default" !== c && {}.hasOwnProperty.call(e, c) && ((r = a && Object.getOwnPropertyDescriptor(e, c)) && (r.get || r.set) ? a(n, c, r) : n[c] = e[c]); return n; }
/**
 * Created By Gems CLI
 * Issues and merge requests are welcomed：https://git.woa.com/hulk/gems
 *
 * API 参考：
 * http://gems.woa.com/?path=/docs/%E5%BC%80%E5%8F%91-%E4%B8%9A%E5%8A%A1%E7%B4%A0%E6%9D%90%E5%BA%93-%E7%BC%96%E5%86%99%E7%BB%84%E4%BB%B6--page
 *
 * @description TpmIntroCardAdvantage
 * @author xlongjiang
 * @created 2025-11-03 05:20:01
 */

/**
 * 格式化组件数据
 * @param properties 组件属性
 * @param options 选项
 * @returns 格式化后的数据
 */
const formatTpmIntroCardAdvantageData = (properties, options = {}) => {
  const _ref = properties || {},
    _ref$porintId = _ref.porintId,
    porintId = _ref$porintId === void 0 ? '' : _ref$porintId,
    _ref$tag = _ref.tag,
    tag = _ref$tag === void 0 ? '' : _ref$tag,
    _ref$title = _ref.title,
    title = _ref$title === void 0 ? '' : _ref$title,
    _ref$desc = _ref.desc,
    desc = _ref$desc === void 0 ? '' : _ref$desc,
    _ref$bg = _ref.bg,
    bg = _ref$bg === void 0 ? 'default' : _ref$bg,
    _ref$bgColor = _ref.bgColor,
    bgColor = _ref$bgColor === void 0 ? '' : _ref$bgColor,
    _ref$bgImg = _ref.bgImg,
    bgImg = _ref$bgImg === void 0 ? '' : _ref$bgImg,
    _ref$items = _ref.items,
    items = _ref$items === void 0 ? [] : _ref$items;
  const handleItems = items.map((item, index) => {
    const _item$img = item.img,
      img = _item$img === void 0 ? '' : _item$img,
      _item$mobileImg = item.mobileImg,
      mobileImg = _item$mobileImg === void 0 ? '' : _item$mobileImg,
      _item$title = item.title,
      title = _item$title === void 0 ? '' : _item$title,
      _item$list = item.list,
      list = _item$list === void 0 ? [] : _item$list;
    return {
      img: (0, _componentUtils.doComponentsUploadEvent)(img || '').url,
      mobileImg: (0, _componentUtils.doComponentsUploadEvent)(mobileImg || '').url,
      title: title,
      list: list.map((listItem, listIndex) => {
        if (!listItem.text) {
          return {
            text: ''
          };
        }

        // 解析混合文本：支持 '我是<Text type="linear">Tencent CVM</Text>' 这种场景
        const parseTextWithTags = text => {
          // 正则匹配 <Text type="xxx">content</Text>
          const textRegex = /<Text\s+(?:[^>]*\s+)?type=["']([^"']+)["'](?:\s+[^>]*)?>(.+?)<\/Text>/gi;
          const parts = [];
          let lastIndex = 0;
          let match;

          // 使用 exec 遍历所有匹配
          while ((match = textRegex.exec(text)) !== null) {
            const _match = match,
              _match2 = (0, _slicedToArray2.default)(_match, 3),
              fullMatch = _match2[0],
              type = _match2[1],
              content = _match2[2];
            const matchIndex = match.index;

            // 添加 <Text> 标签前的普通文本
            if (matchIndex > lastIndex) {
              const plainText = text.substring(lastIndex, matchIndex);
              if (plainText) {
                parts.push(plainText);
              }
            }

            // 添加 <Text> 组件
            const hasHtmlTags = /<[^>]+>/.test(content);
            parts.push(/*#__PURE__*/React.createElement(_tpmProductIntl.Text, {
              key: `text-${index}-${listIndex}-${parts.length}`,
              type: type.trim()
            }, hasHtmlTags ? /*#__PURE__*/React.createElement(_HTMLRenderer.default, {
              html: content
            }) : content));
            lastIndex = matchIndex + fullMatch.length;
          }

          // 添加最后剩余的普通文本
          if (lastIndex < text.length) {
            const remainingText = text.substring(lastIndex);
            if (remainingText) {
              parts.push(remainingText);
            }
          }

          // 如果没有匹配到任何 <Text> 标签，直接用 HTMLRenderer 处理
          if (parts.length === 0) {
            return /*#__PURE__*/React.createElement(_HTMLRenderer.default, {
              html: text
            });
          }

          // 返回包含多个部分的 Fragment
          return /*#__PURE__*/React.createElement(React.Fragment, null, parts);
        };
        return {
          text: parseTextWithTags(listItem.text)
        };
      })
    };
  });
  return {
    porintId,
    tag,
    title: title ? /*#__PURE__*/React.createElement(_HTMLRenderer.default, {
      html: title
    }) : '',
    desc: desc ? /*#__PURE__*/React.createElement(_HTMLRenderer.default, {
      html: desc
    }) : '',
    bg,
    bgColor,
    bgImg: (0, _componentUtils.doComponentsUploadEvent)(bgImg || '').url,
    items: handleItems
  };
};
function _default({
  componentKey,
  // {number} 用于标识每一个组件实例的全局唯一且持久化的 key
  data,
  // {object} "数据"表单内容
  style,
  // {object} "样式"表单内容
  commonStyle,
  // {object} "组件自定义样式"表单内容
  global,
  // {object} 页面容器自定义的全局配置项
  meta,
  // {object} 页面元数据
  componentsMap,
  // {Map<number, HTMLElement>} 所有组件 DOM 节点的 Map，key 为组件的 key（number）
  getComponentByKey,
  // {(key: number) => HTMLElement | undefined} 通过组件 key 获取组件 DOM 节点的 API
  store,
  // {object} 组件状态
  on,
  // {(event: string, callback: Function) => void} 事件触发调用
  emit,
  // {(event: string) => void | Promise<void>} 监听事件
  domains: domainInfos
}) {
  const domains = (0, _gemUrlFormatUtils.useDomainGems)({
    domainInfos
  });
  if (Object.keys(data).length > 1) {
    const _formatTpmIntroCardAd = formatTpmIntroCardAdvantageData(data, {
        domains
      }),
      porintId = _formatTpmIntroCardAd.porintId,
      tag = _formatTpmIntroCardAd.tag,
      title = _formatTpmIntroCardAd.title,
      desc = _formatTpmIntroCardAd.desc,
      bg = _formatTpmIntroCardAd.bg,
      bgColor = _formatTpmIntroCardAd.bgColor,
      bgImg = _formatTpmIntroCardAd.bgImg,
      items = _formatTpmIntroCardAd.items;
    return /*#__PURE__*/React.createElement("div", Object.assign({
      id: porintId,
      className: `gems-materials-qci____newUI-TpmIntroCardAdvantage`
    }, (0, _reportUtil.reportShow)(['show_newUI_TpmIntroCardAdvantage', componentKey, title || ''])), /*#__PURE__*/React.createElement(_tpmProductIntl.Section, {
      tag: tag,
      title: title,
      desc: desc,
      bg: bg,
      bgColor: bgColor,
      bgImg: bgImg
    }, /*#__PURE__*/React.createElement(_tpmProductIntl.IntroCard4, {
      data: items
    })));
  } else {
    return /*#__PURE__*/React.createElement("div", null);
  }
}